import { useEffect, useState } from "react"
import { OpsInputStep } from "./OpsInputStep"
import OpsSummaryStep from "./OpsSummaryStep"
import { ProcessCards, } from "./ProcessCards"
import { useAuth } from "../../../../../auth"
import axios from "axios"
import { toast } from "react-toastify"

export default function ProcessMaterial() {
    const [step, setStep] = useState(1)
    const nextStep = () => setStep(prev => Math.min(prev + 1, 3))
    const prevStep = () => setStep(prev => Math.max(prev - 1, 1))

    const { auth }: any = useAuth()
    const [activeTab, setActiveTab] = useState<'NON_DIVERSION' | 'DIVERSION'>('NON_DIVERSION')
    const [processes, setProcesses] = useState<any[]>([])
    const [selectedProcess, setSelectedProcess] = useState<any>(null)
    const [isLoading, setIsLoading] = useState(false)
    const [error, setError] = useState<string | null>(null)

    //---------------User Input items-------------------
    const [inputMaterial, setInputMaterial] = useState<any[]>([])
    const [outputMaterial, setOutputMaterial] = useState<any[]>([])
    const [productionDate, setProductionDate] = useState(new Date());
    const [actualProductionDate, setActualProductionDate] = useState(new Date());
    const [productionHours, setProductionHours] = useState(0);
    const [productionCrew, setProductionCrew] = useState(0);
    const [productionShift, setProductionShift] = useState(1)
    const [productImage1, setProductImage1] = useState<string>('')
    const [productImage2, setProductImage2] = useState<string>('')

    const fetchProcesses = async () => {
        setIsLoading(true)
        setError(null)
        try {
            const response = await axios.get(`${process.env.REACT_APP_BASE_API_URL}materialProcesses`, {
                headers: {
                    'app-id': '3',
                    'client-id': auth?.data?.clientId
                }
            })
            setProcesses(response.data?.data || [])
        } catch (err: any) {
            console.error('Error fetching material processes:', err)
            setError('Failed to load processes. Please try again later.')
        } finally {
            setIsLoading(false)
        }
    }

    useEffect(() => {
        fetchProcesses()
    }, [])

    useEffect(() => {
        if (selectedProcess?.id) {
            setInputMaterial(selectedProcess?.inMaterials?.filter((material: any) => material?.stock > 0))
            setOutputMaterial(selectedProcess?.outMaterials)
        }
    }, [selectedProcess])

    const formatDate = (date: Date) => {
        const d = new Date(date)
        const day = String(d.getDate()).padStart(2, '0')
        const month = String(d.getMonth() + 1).padStart(2, '0')
        const year = d.getFullYear()
        return `${day}/${month}/${year}`
    }

    const handleSubmit = async () => {
        setIsLoading(true)
        try {
            // Mapping production data
            const productionItem: any = {}
            const packingUnit: any = {}
            const packingBagInfo: any[] = []

            outputMaterial?.filter(m => m.enteredValue > 0).forEach((m, index) => {
                productionItem[m.id] = m.enteredValue
                packingUnit[m.id] = 1 // Default as per payload
                packingBagInfo.push({
                    bagId: (index + 1).toString(),
                    weight: m.enteredValue,
                    itemId: m.id,
                    createdAt: formatDate(new Date()) + " " + new Date().toLocaleTimeString(),
                    categoryName: m.categoryName || 'RECYCLABLE',
                    itemName: m.name,
                    categoryId: m.categoryId || ''
                })
            })

            const payload = {
                userId: auth?.data?.userId,
                processId: selectedProcess?.id,
                processName: selectedProcess?.name,
                processType: selectedProcess?.processType,
                productionItem,
                packingUnit,
                wastage: 0,
                inputMaterial: inputMaterial?.filter(m => m.enteredValue > 0).map(m => ({
                    materialTypeId: m.id,
                    inputQuantity: m.enteredValue.toString(),
                    inputMaterialName: m.name,
                    inputMaterialCategoryId: m.categoryId,
                    inputMaterialCategoryName: m.categoryName
                })),
                images: [productImage1, productImage2].filter(img => img !== ''),
                processDate: productionDate.getTime(),
                actualProcessDate: formatDate(actualProductionDate),
                operatingHours: productionHours.toString(),
                teamSize: productionCrew.toString(),
                shift: productionShift.toString(),
                packingBagInfo
            }

            console.log("Submitting payload:", payload)

            const response = await axios.post(`${process.env.REACT_APP_BASE_API_URL}production`, payload, {
                headers: {
                    'app-id': '3',
                    'client-id': auth?.data?.clientId
                }
            })

            if (response.status === 200 || response.status === 201) {
                toast.success('Production data submitted successfully!')
                // Navigate back or reset state
                setStep(1)
                setSelectedProcess(null)
            } else {
                toast.error('Failed to submit production data. Please try again.')
            }
        } catch (err: any) {
            console.error('Error submitting production data:', err)
            toast.error(err?.response?.data?.message || 'Error occurred while submitting.')
        } finally {
            setIsLoading(false)
        }
    }

    return (
        <div>
            {step === 1 && <ProcessCards onNext={nextStep} activeTab={activeTab} setActiveTab={setActiveTab} processes={processes} isLoading={isLoading} error={error} setSelectedProcess={setSelectedProcess} />}
            {step === 2 && <OpsInputStep onNext={nextStep} onBack={prevStep} selectedProcess={selectedProcess} inputMaterial={inputMaterial} outputMaterial={outputMaterial} setInputMaterial={setInputMaterial} setOutputMaterial={setOutputMaterial} />}
            {step === 3 && <OpsSummaryStep onBack={prevStep} selectedProcess={selectedProcess} inputMaterial={inputMaterial} outputMaterial={outputMaterial} productionDate={productionDate} setProductionDate={setProductionDate} actualProductionDate={actualProductionDate} setActualProductionDate={setActualProductionDate} productionHours={productionHours} setProductionHours={setProductionHours} productionCrew={productionCrew} setProductionCrew={setProductionCrew} productionShift={productionShift} setProductionShift={setProductionShift} productImage1={productImage1} setProductImage1={setProductImage1} productImage2={productImage2} setProductImage2={setProductImage2} handleSubmit={handleSubmit} isSubmitting={isLoading} />}
        </div>
    )
}